import { createContext, useContext } from "react";
export const CustomButtonContext = createContext({});
export const useCustomButtons = () => useContext(CustomButtonContext);
